import React, { useState, useEffect, useContext } from "react";
import { Button, Layout, DeleteChildDialog, Loader, Icon } from "@app/components";
import { useLocation } from "@app/utils";
import { AuthContext } from "@app/providers";
import { StudentDetailWrapper } from "../educator/educator-component";
import { ActionButton, ActionsWrapper, DefaultMessage, FormFlexWrapper, FormHeader, FormTitle, EmptyContainer } from "@app/components/commonStyles";
import { ClassroomList, Label, Value } from "./classroom-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { whiteColor } from "@app/styles";
import { faPencilAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { getClassroom, deleteClassroom, getUser } from "@app/services";
import { GoogleSVG } from "@app/assets";

export default function Classrooms() {
    const { userInfo }: any = useContext(AuthContext);
    const { navigate, location } = useLocation();
    const userToken = userInfo && userInfo.sessionToken;
    const [showDelete, setShowDelete] = useState<boolean>(false);
    const [deleteText, setDeleteText] = useState<string>("Delete");
    const [userDetails, updateUserDetails] = useState<any>();
    const [classroomsList, setClassroomsList] = useState<any>([]);
    const [classroomId, setClassroomId] = useState()
    const [spinner, setSpinner] = useState(true)
    const [childDetails, setChildDetails] = useState([])
    const [parentChildClassCount, setParentChildClass] = useState<any>()
    const [userDetail, setUserDetails] = useState(userInfo && userInfo.userJson);
    const [studNouser, showStudNoUser] = useState([])
    const [clssroomId, setClassRoomId] = useState()

    useEffect(() => {
        setSpinner(true)
        if (!userToken) {
            navigate("/sign-in")
        }
        if (userInfo && userInfo.userJson.userType === "student") {
            studentUser()
        }


        if (userInfo && userInfo.userJson.userType === "parent") {
            studentUser()
            setSpinner(true)
            let totalCount = 0;
            userInfo.userJson.childDetails && userInfo.userJson.childDetails.forEach((row: any) => {
                if (row.classRoomsDetails) {
                    totalCount = totalCount + row.classRoomsDetails.length
                }
            })
        }
        if (userInfo && userInfo.userJson.userType === "educator") {
            setSpinner(true)
            if (localStorage.getItem("classRooms")) {
                setTimeout(() => {
                    let classes = JSON.parse(localStorage.getItem("classRooms") || '')
                    setClassroomsList(classes)
                    setSpinner(false)
                }, 700);
                
            } else getClassroomDetails()

        }
    }, [userInfo]);

    const studentUser = () => {
        const params: any = {};
        // setSpinner(true)
        Object.assign(params, {
            sessionToken: userInfo && userInfo.sessionToken,
            userId: userInfo && userInfo.userJson.userId,
        });
        getUser(params)
            .then((res) => {
                if (res._responseStatus === 1) {
                    const user = JSON.parse(res.userJson);
                    setUserDetails(user);
                    setChildDetails(user.childDetails)
                    showStudNoUser(user)
                    setSpinner(false)
                    let totalCount = 0;
                    user.childDetails && user.childDetails.forEach((row: any) => {
                        if (row.classRoomsDetails) {
                            totalCount = totalCount + row.classRoomsDetails.length
                        }
                    })
                    setParentChildClass(totalCount)
                }
            })
    }


    const getClassroomDetails = () => {
        const params: any = {};
        Object.assign(params, {
            sessionToken: userInfo && userInfo.sessionToken,
            userId: userInfo && userInfo.userJson.userId,
        });
        setSpinner(true)

        getClassroom(params)
            .then((resp: any) => {
                const response = resp;
                if (response._responseStatus === 1) {
                    localStorage.setItem("classRooms", JSON.stringify(response.allClassroomsDocs))
                    let classes = JSON.parse(localStorage.getItem("classRooms") || '')
                    setClassroomsList(classes)
                    // setClassroomsList(response.allClassroomsDocs)
                    setSpinner(false)
                    setClassRoomId(response.allClassroomsDocs[0].classRoomId)
                    
                }
                else {
                    // setClassroomsList(response.allClassroomsDocs)
                    setSpinner(false)
                }
            })

        if (userInfo && userInfo.sessionToken) {
            const user = userInfo.userJson;
            updateUserDetails(user);
        }
    }
    const DeleteClassroom = (id: any) => {
        setSpinner(false)
        const params: any = {};
        Object.assign(params, {
            sessionToken: userInfo && userInfo.sessionToken,
            userId: userInfo && userInfo.userJson.userId,
            classRoomId: id,
        });
        deleteClassroom(params)
            .then((resp: any) => {
                const response = resp;
                if (response._responseStatus === 1) {
                    let classes = JSON.parse(localStorage.getItem("classRooms") || '')
                    classes.filter((classId: any, index: number) => {
                        if (classId.classRoomId == id) {
                            classes.splice(index, 1)
                            localStorage.removeItem("classroomDetails")
                        }
                    })
                    localStorage.setItem("classRooms", JSON.stringify(classes))
                    setClassroomsList(classes)
                    setShowDelete(false)

                }
            })

    }
    const openConfirm = (classroomId: any) => {
        setClassroomId(classroomId)
        setShowDelete(true)
    }
    const getConfirm = (evt: any) => {
        if (evt) {
            DeleteClassroom(classroomId)
        }
    }
    const getStudents = (evt: any) => {
        navigate('/add-students/' + evt)
    }
    const listStudents = (evt: any) => {
        navigate('/list-students/' + evt)
    }
    const editClass = (evt: any) => {
        let classRoomDetails: any = {
            classroomName: evt.classRoomName,
            classGrade: evt.classRoomGrade,
            subject: evt.classRoomSubject,
            studentsCount: evt.noOfStudents,
            classRoomId: evt.classRoomId,
            teacherName: evt.teacherName,
            studentIds: evt.studentIds,
            googleClassroomId: evt.googleClassroomId
        }

        localStorage.setItem("classroomDetails", JSON.stringify(classRoomDetails))
        navigate('/edit-classroom/' + evt.classRoomId)
    }

    function PortalRedirection() {
        if (userInfo && userInfo.userJson.userType === "educator") {
            navigate('/educator')
        } else if (userInfo && userInfo.userJson.userType === "parent") {
            navigate('/linked-child')
        } else {
            navigate('/create-avatar')
        }
    }

    return (
        <>
            <Layout>
                <FormHeader className="mb-3">
                    <span className="back-icon" onClick={() => PortalRedirection()}>
                        <Icon name="backArrow" />
                    </span>
                    <FormTitle className="justify-center">
                        <h3 className="primary-header text-center"> {userInfo && userInfo.userJson.userType === "educator" ||
                            userInfo && userInfo.userJson.userType === "student" ? "My Classroom(s)" : "My Child's Classroom(s)"}</h3>
                    </FormTitle>
                </FormHeader>
                <ClassroomList>
                    {/* {!classroomsList &&
                        <EmptyContainer>
                            <Icon name="loader" />
                            <DefaultMessage>Loading, please wait...</DefaultMessage>
                        </EmptyContainer>
                    } */}
                    {userInfo && userInfo.userJson.userType === "student" && userDetail.classRoomsDetails && userDetail.classRoomsDetails.length ? <h4 className="secondary-header">
                        Classrooms ({userDetail.classRoomsDetails && userDetail.classRoomsDetails.length}) </h4> : ''}

                    {userInfo && userInfo.userJson.userType === "student" && userDetail.classRoomsDetails && userDetail.classRoomsDetails.map((studentDetail: any, index: number) => {
                        return (
                            <StudentDetailWrapper key={studentDetail.index}>
                                <FormFlexWrapper className="two-child-layout mb-2">
                                    <div className="child">
                                        <Label>Classroom Name
                                            {studentDetail.googleClassroomId != undefined &&
                                                <img src={GoogleSVG} width="24px"></img>
                                            }
                                        </Label>
                                        <Value>{studentDetail.classRoomName}</Value>
                                    </div>

                                    <div className="child">
                                        <Label>Teacher Name</Label>
                                        <Value>{studentDetail.teacherName}</Value>
                                    </div>
                                </FormFlexWrapper>
                                <FormFlexWrapper className="two-child-layout mb-0">
                                    <div className="child">
                                        <Label>Subject</Label>
                                        <Value>{studentDetail.classRoomSubject}</Value>
                                    </div>
                                    <div className="child"></div>

                                </FormFlexWrapper>
                            </StudentDetailWrapper>

                        )
                    })}


                    {userInfo && userInfo.userJson.userType === "parent" && childDetails && childDetails.length ? <h4 className="secondary-header">
                        Classrooms ({parentChildClassCount}) </h4> : ''}

                    {userInfo && userInfo.userJson.userType === "parent" && childDetails && childDetails.map((student: any, index: number) => {
                        return (
                            <>
                                {student.classRoomsDetails && student.classRoomsDetails.map((data: any, index: number) => {
                                    return (
                                        <StudentDetailWrapper key={data.index}>
                                            <FormFlexWrapper className="two-child-layout mb-2">
                                                <div className="child">
                                                    <Label>Child Name</Label>
                                                    <Value>{student.firstName + ' ' + student.lastName}</Value>
                                                </div>
                                                <div className="child">
                                                    <Label>Teacher Name</Label>
                                                    <Value>{data.teacherName}</Value>
                                                </div>
                                            </FormFlexWrapper>
                                            <FormFlexWrapper className="two-child-layout mb-0">
                                                <div className="child">
                                                    <Label>Classroom Name </Label>
                                                    <Value>{data.classRoomName}</Value>
                                                </div>
                                                <div className="child">
                                                    <Label>No. of Students</Label>
                                                    <Value> {data.studentIds?.length}</Value>
                                                </div>
                                            </FormFlexWrapper>
                                        </StudentDetailWrapper>

                                    )
                                })
                                    // :
                                    // <StudentDetailWrapper key={index}>
                                    //     <FormFlexWrapper className="two-child-layout mb-2">
                                    //         <div className="child">
                                    //             <Label>Child Name</Label>
                                    //             <Value>{student.firstName}</Value>
                                    //         </div>
                                    //     </FormFlexWrapper>
                                    //     <EmptyContainer className="without-pos alt-padding">
                                    //         <DefaultMessage>No Classrooms found</DefaultMessage>
                                    //     </EmptyContainer>
                                    // </StudentDetailWrapper>
                                }

                            </>
                        )
                    })}

                    {classroomsList.length === 0 ? '' : <h4 className="secondary-header">Classrooms ({classroomsList && classroomsList.length})</h4>}

                    {classroomsList && classroomsList.map((classroom: any, index: number) => {
                        return (
                            <StudentDetailWrapper key={classroom.index}>
                                <FormFlexWrapper className="two-child-layout mb-2">
                                    <div className="child">
                                        <Label>Classroom Name
                                        </Label>
                                            
                                        <Value>{classroom.classRoomName}</Value>
                                    </div>
                                    <div className="child">
                                        <Label>Grade</Label>
                                        <Value>{classroom.classRoomGrade}</Value>
                                    </div>
                                </FormFlexWrapper>
                                <FormFlexWrapper className="two-child-layout mb-2">
                                    <div className="child">
                                        <Label>Subject </Label>
                                        <Value>{classroom.classRoomSubject}</Value>
                                    </div>
                                    <div className="child">
                                        <Label>Max No. of Students</Label>
                                        <Value>
                                            {classroom.studentIds?.length} of {classroom.noOfStudents}
                                            {/* {console.log(classroom.studentData.length)} */}
                                            {/* {console.log(classroom.studentIds.length)} */}
                                            {/* {userInfo && userInfo.userJson.userType === "educator" ?
                                                <span className="anchor-tag" onClick={(evt: any) => getStudents(classroom.classRoomId)}>
                                                    {classroom.studentIds.length ? "View Students" : "Add Student"}
                                                    ({classroom.studentIds.length})
                                                </span> : ''} */}
                                        </Value>
                                    </div>
                                </FormFlexWrapper>
                                <FormFlexWrapper className="two-child-layout mb-0">
                                    <div className="child">
                                        <Label>Teacher Name</Label>
                                        <Value>{classroom.teacherName || "--"} </Value>
                                    </div>
                                    <div className="child">
                                        {userInfo && userInfo.userJson.userType === "educator" ?
                                            <span>
                                                <span className="anchor-tag" onClick={(evt: any) => getStudents(classroom.classRoomId)}>
                                                    {classroom.studentIds?.length ? "Add Students" : "Add Student"}
                                                    {/* ({classroom.studentIds.length}) */}
                                                </span> 
                                                <br/>
                                                <br/>
                                                <span className="anchor-tag" onClick={(evt: any) => listStudents(classroom.classRoomId)}>
                                                    {classroom.studentIds?.length ? "List Students" : ""}
                                                </span>
                                            </span>
                                            : ''}
                                    </div>
                                </FormFlexWrapper>
                                {userInfo && userInfo.userJson.userType === "educator" ?
                                    <ActionsWrapper className="top-right-positioned">
                                        <ActionButton style={{cursor:"default"}}>
                                            {classroom.googleClassroomId !== undefined && classroom.googleClassroomId != "" && classroom.googleClassroomId != "false" &&
                                                <img src={GoogleSVG} style={{width:"30px"}}></img>
                                            }
                                        </ActionButton>
                                        <ActionButton className="success" title="Edit Classroom" onClick={(e: any) => editClass(classroom)}>
                                            <FontAwesomeIcon
                                                color={whiteColor}
                                                icon={faPencilAlt}
                                                size="sm"
                                            />
                                        </ActionButton>
                                        <ActionButton className="danger" title="Delete Classroom" onClick={(e: any) => { openConfirm(classroom.classRoomId); }}>
                                            <FontAwesomeIcon
                                                color={whiteColor}
                                                icon={faTrashAlt}
                                                size="sm"
                                            />
                                        </ActionButton>
                                    </ActionsWrapper> : ''
                                }
                            </StudentDetailWrapper>

                        )
                    })}
                    {userInfo && userInfo.userJson.userType === "educator" && classroomsList.length === 0 && spinner === false &&
                        <EmptyContainer>
                            <DefaultMessage className="mb-2 medium-font">No Classroom created yet!</DefaultMessage>
                            {userInfo && userInfo.userJson.userType === "educator" ?
                                <DefaultMessage className="small-font"> Click here to <span onClick={() => navigate('/create-classroom')} className="anchor-tag small-font"> Create Classroom </span></DefaultMessage> : ''}
                        </EmptyContainer>
                    }
                    {userInfo && userInfo.userJson.userType === "student" && userDetail && userDetail.classRoomsDetails && userDetail.classRoomsDetails.length === 0 &&
                        <EmptyContainer>
                            <DefaultMessage className="mb-2 medium-font">No Classroom created yet!</DefaultMessage>
                        </EmptyContainer>
                    }
                    {userInfo && userInfo.userJson.userType === "parent" && childDetails && !childDetails.length && spinner === false &&
                        <EmptyContainer>
                            <DefaultMessage className="mb-2">No Children linked yet!</DefaultMessage>
                        </EmptyContainer>
                    }
                    {userInfo && userInfo.userJson.userType === "parent" && childDetails && childDetails.length && parentChildClassCount === 0 && spinner === false ?
                        <EmptyContainer>
                            <DefaultMessage className="mb-2">No Classrooms created yet for any child!</DefaultMessage>
                        </EmptyContainer>
                        : ""}
                </ClassroomList>

                {spinner &&
                    <EmptyContainer>
                        <Icon name="loader" />
                        <DefaultMessage>Loading, please wait...</DefaultMessage>
                    </EmptyContainer>
                }
                {userInfo && userInfo.userJson.userType === "educator" ? <>
                    {classroomsList.length === 0 ? '' : <button type="button" className="anchor-tag d-block text-center mx-auto mt-3 mb-2"
                        onClick={() => navigate("/create-classroom")} >
                        + Create Classroom</button>}

                    {/* <ButtonContainer>
                        <Button
                            type="submit"
                            variant="newsecondary"
                            size="large"
                            width="100%"
                            disabled={classroomsList.length === 0 ? true : false}
                        // onClick={() => ()}
                        >
                            Submit
            </Button>
                    </ButtonContainer> */}
                </>
                    : ''}
                {<Button variant="bordered" width="100%" size="large" onClick={() => navigate(userInfo.userJson.userType === "educator" ? '/educator' : '' ||
                    userInfo.userJson.userType === "parent" ? "/linked-child" : '' ||
                        userInfo.userJson.userType === "student" ? "/create-avatar" : '')}
                >Cancel</Button>}

            </Layout>
            {showDelete &&
                <DeleteChildDialog
                    // dialogTitle="Confirm Removal"
                    noTitle={true}
                    confirmationText="Are you sure you want to delete the Classroom?"
                    confirmationMsg="The Classroom will be deleted. You can add again at anytime."
                    deleteText={deleteText}
                    onClose={() => setShowDelete(false)}
                    deleteChild={getConfirm}
                />

            }
        </>
    );
}
